import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Rabbit } from 'lucide-react';

export const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Amplify handles the OAuth callback automatically
    // Just redirect to home after a short delay
    const timer = setTimeout(() => {
      navigate('/', { replace: true });
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-rutabaga-bg flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-rutabaga-text rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
          <Rabbit className="text-white w-10 h-10" />
        </div>
        <h2 className="text-xl font-heading font-bold text-rutabaga-text mb-2">
          Completing sign-in...
        </h2>
        <p className="text-gray-500">
          Please wait while we finish setting up your account.
        </p>
      </div>
    </div>
  );
};
